import $ from 'jquery'
import axios from 'axios'
import {baseUrl, backofficeUrl} from '../config'
import state from './state'

export default {

  //
  // Login
  //

  login (login, password) {
    const body = {
      'login': login,
      'password': password,
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/login', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  logout() {
    const body = {
      'revokedToken': localStorage.getItem('TOKEN'),
    }
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/logout', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          //window.location.reload()
        }
        reject(err)
      })
    })
  },
  getUserByLogin (login) {

    const body = {
      'login': login
    }

    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/maitrises/username', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  forgotPassword (recipient, id) {
    const body = {
      'recipient': recipient,
      'link': backofficeUrl + '/resetPassword' + '/' + id
    }
    console.log('link  =>  ', backofficeUrl + '/resetPassword' + '/' + id)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/mail/send-email', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  resetPasssword (id, password) {
    const body = {
      'id': id,
      'password': password
    }
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/auth/pwd_reset', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getEmail (login) {
    const body = {
      'login': login
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/maitrises/email', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

  //
  // Tournées
  //

  getTourneesOnly () {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': state.currentVille.id
      }
      axios.post(baseUrl + '/tournees/only/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  closeTournee(tournee_id) {
    return new Promise((resolve, reject) => {
      axios.post(`${baseUrl}/tournees/${tournee_id}/close`, {"codeTypeFermeture": "FBO"}, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getTourneesByDate (day) {
    console.log('the day => ', day)
    const body = {
      'day': day,
      'ville_id': state.currentVille.id,
    }
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getTourneesOnlyByDate (day) {
    console.log('the day => ', day)
    const body = {
      'day': day,
      'ville_id': state.currentVille.id,
    }
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/only/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getTourneeById (id_tournee) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/tournees/' + id_tournee, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getRealTimeTournees (day, mode) {
    const body = {
      'day': day,
      'statusTournee': mode,
      'ville_id': state.currentVille.id,
    }
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/tournees/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

  //
  // Maitrises
  //

  getAllMaitrises () {
    return new Promise((resolve, reject) => {
        axios.get(baseUrl + '/maitrises', {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          }
        }).then((res) => {
          resolve(res)
        }).catch(err => {
          if (err.response && err.response.status && err.response.status === 401) {
            localStorage.clear()
            state.login.loggedIn = false
            window.location.reload()
          }
          reject(err)
        })
      }
    )
  },
  getAllMaitrisesByVilleId (ville_id, arrondissement_id) {
    return new Promise((resolve, reject) => {
        const body = {
          'ville_id': ville_id,
          'arrondissement_id': arrondissement_id,
        }
        axios.post(baseUrl + '/maitrises/search', body, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          }
        }).then((res) => {
          resolve(res)
        }).catch(err => {
          if (err.response && err.response.status && err.response.status === 401) {
            localStorage.clear()
            state.login.loggedIn = false
            window.location.reload()
          }
          reject(err)
        })
      }
    )
  },
  createMaitrise (maitrise) {
    console.log('api maitrise ==> ', maitrise)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/maitrises/user', maitrise, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateMaitrise (maitrise_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + maitrise_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  reactivateMaitrise (maitrise_id) {
    let body = {
      'actif': true
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + maitrise_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateMaitrise (maitrise, id) {
    console.log('api maitrise ==> ', maitrise)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + id, maitrise, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

  getAllUsers () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/maitrises', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createUser (maitrise) {
    console.log('api user ==> ', maitrise)
    return new Promise((resolve, reject) => {
      let userCreationMapping = maitrise.isSuperAdmin ? '/maitrises/admin' : (maitrise.isCollectivite ? '/maitrises/collectivity' : '/maitrises/user')
      axios.post(baseUrl + userCreationMapping, maitrise, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateUser (maitrise_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + maitrise_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deleteUser (maitrise_id) {
    return new Promise((resolve, reject) => {
      axios.delete(baseUrl + '/maitrises/' + maitrise_id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  reactivateUser (maitrise_id) {
    let body = {
      'actif': true
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + maitrise_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateUser (maitrise, id) {
    console.log('api user ==> ', maitrise)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/maitrises/' + id, maitrise, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

//
// Ville
//

  getAllVilles () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/villes', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getVilleOfCurrentUser (id_ville) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/villes/' + id_ville, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateModuleBo (module) {
    let body = {
      actif: module.actif
    }
    console.log('module ==> ', module)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/parametragebos/' + module.id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateModuleApk (module) {
    let body = {
      actif: module.actif
    }
    console.log('module ==> ', module)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/parametrageapks/' + module.id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

//
// Arrondissement
//

  getAllArrondissements () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/arrondissements', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },



//
// Materiels
//
  getActifMaterielsByVilleId () {
    return new Promise((resolve, reject) => {
      const body = {
        'actif': true,
        'ville_id': state.currentVille.id,
      }
      axios.post(baseUrl + '/materiels/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllMateriels () {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/materiels', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getMaterielsOfVille (id_ville) {
    const body = {
      'ville_id': id_ville
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/materiels/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllMaterielsByVilleId (ville_id, arrondissement_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
        'arrondissement_id': arrondissement_id,
        'actif': true,
      }
      axios.post(baseUrl + '/materiels/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createMateriel (materiel) {
    console.log('api materiel ==> ', materiel)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/materiels', materiel, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateMateriel (materiel_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/materiels/' + materiel_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateMateriel (materiel, id) {
    console.log('api materiel ==> ', materiel)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/materiels/' + id, materiel, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllMaterielPermissByVilleId (ville_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
      }
      axios.post(baseUrl + '/materielpermiss/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

//
// Secteurs
//

  getSecteursOfVille (id_ville) {
    const body = {
      'ville_id': id_ville,
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/secteurs/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllSecteursByVilleId (ville_id, arrondissement_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
        'arrondissement_id': arrondissement_id,
        'actif': true,
      }
      axios.post(baseUrl + '/secteurs/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createSecteur (secteur) {
    console.log('api secteur ==> ', secteur)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/secteurs', secteur, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateSecteur (secteur_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/secteurs/' + secteur_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateSecteur (secteur, id) {
    console.log('api secteur ==> ', secteur)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/secteurs/' + id, secteur, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getSecteursByVilleId () {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': state.currentVille.id,
      }
      axios.post(baseUrl + '/secteurs/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getSecteurById (id) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/secteurs/' + id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },



  //
  // Demandes
  //

  getAllDemandesByVilleId (ville_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
        'arrondissement_id': state.currentUser.arrondissement_id
      }
      axios.post(baseUrl + '/demandes/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createDemande (demande) {
    console.log('api demande ==> ', demande)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/demandes', demande, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateDemande (demande, demande_id) {
    console.log('update api demande ==> ', demande)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/demandes/' + demande_id, demande, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  cancelDemande (demande, demande_id) {
    console.log('cancel api demande ==> ', demande)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/demandes/' + demande_id, demande, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

//
// Photos
//

  getPhotoById (id_photo) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/photos/' + id_photo, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  }
  ,

//
// Contenants
//

  getContenantsOfVille (id_ville) {
    const body = {
      'ville_id': id_ville,
      'actif': true,
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/contenants/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllContenants (ville_id) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/contenants', {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllContenantsByVilleId (ville_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
      }
      axios.post(baseUrl + '/contenants/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateContenant (contenant_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/contenants/' + contenant_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createContenant (contenant) {
    console.log('api contenant ==> ', contenant)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/contenants', contenant, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateContenant (contenant, id) {
    console.log('api contenant ==> ', contenant)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/contenants/' + id, contenant, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

  getCantonniersByVilleId () {
    return new Promise((resolve, reject) => {
      const body = {
        //'actif': true,
        'ville_id': state.currentVille.id,
      }
      axios.post(baseUrl + '/cantonniers/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getArrondissementById (id) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/arrondissements/' + id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

  //
  // KPI'S
  //

  getStatistiquesForVille (id_ville, year) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': id_ville,
        'year': year
      }
      axios.post(baseUrl + '/graphs', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },


  //
  // Cantonniers
  //
  getCantonnierById (id) {
    return new Promise((resolve, reject) => {
      axios.get(baseUrl + '/cantonniers/' + id, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getCantonniersOfCurrentVille (id_ville) {
    const body = {
      'ville_id': id_ville
    }
    console.log('body => ', body)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/cantonniers/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((response) => {
        resolve(response)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  getAllCantonniersByVilleId (ville_id, arrondissement_id) {
    return new Promise((resolve, reject) => {
      const body = {
        'ville_id': ville_id,
        'arrondissement_id': arrondissement_id,
        'actif': true
      }
      axios.post(baseUrl + '/cantonniers/search', body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  createCantonnier (cantonnier) {
    console.log('api cantonnier ==> ', cantonnier)
    return new Promise((resolve, reject) => {
      axios.post(baseUrl + '/cantonniers', cantonnier, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  deactivateCantonnier (cantonnier_id) {
    let body = {
      'actif': false
    }
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/cantonniers/' + cantonnier_id, body, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },
  updateCantonnier (cantonnier, id) {
    console.log('api cantonnier ==> ', cantonnier)
    return new Promise((resolve, reject) => {
      axios.patch(baseUrl + '/cantonniers/' + id, cantonnier, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
        }
      }).then((res) => {
        resolve(res)
      }).catch(err => {
        if (err.response && err.response.status && err.response.status === 401) {
          localStorage.clear()
          state.login.loggedIn = false
          window.location.reload()
        }
        reject(err)
      })
    })
  },

//
// Reporting
//
getTournees (uniqueTourneeIds) {
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + '/tournees/findAllByIds', uniqueTourneeIds, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
      }
    }).then((res) => {
      resolve(res)
    }).catch(err => {
      if (err.response && err.response.status && err.response.status === 401) {
        localStorage.clear()
        state.login.loggedIn = false
        window.location.reload()
      }
      reject(err)
    })
  })
},

  reverseGeocode (geopassage) {
    if (geopassage.coords.lat !== undefined && geopassage.coords.lon !== undefined) {
      const coords = {
        coords: {
          lat: geopassage.coords.lat,
          lon: geopassage.coords.lon, // Example coordinates (Paris)
        },
      };
      return new Promise((resolve, reject) => {
        axios.post(baseUrl + '/remonteegpss/reverse', coords, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('TOKEN')}`
          }
        })
        .then((res) => {
          resolve(geopassage)
          geopassage.numeroVoie = res.data.numeroVoie;
          geopassage.voie = res.data.voie;
        }).catch(err => {
          if (err.response && err.response.status && err.response.status === 401) {
            localStorage.clear()
            state.login.loggedIn = false
            window.location.reload()
            console.error("Error fetching reverse geocode datadata:");
          }
          reject(err)
      })
      console.log("Recupereation geocode data done");
    })
  }
},

  getDataFromGoogleApiResults(geopassage, res) {
    try {
      geopassage.numeroVoie = res.numeroVoie;
      geopassage.voie = res.voie;
      console.log("Geopassage Data recupered:");
    } catch (error) {
      console.error("Error fetching reverse geocode data:", error);
    }
  },

  getAllTourneesByVilleId (ville_id) {
      return new Promise((resolve, reject) => {
        const body = {
          'ville_id': ville_id
        }
        axios.post(baseUrl + '/tournees/byVille1', body, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + localStorage.getItem('TOKEN'),
          }
        }).then((res) => {
          resolve(res)
        }).catch(err => {
          if (err.response && err.response.status && err.response.status === 401) {
            localStorage.clear()
            state.login.loggedIn = false
            window.location.reload()
          }
          reject(err)
        })
      })
    },

/* getDataFromGoogleApiResults (geopassage, res) {
  //console.log(res)
  let addressComponents = res[0].address_components
  let streetNumber = addressComponents.find(function (ac) {
    return ac.types.indexOf('street_number') !== -1
  })
  // il s'avère que sur certains cas, le point GPS n'est pas associé à une rue ...
  let avenue = addressComponents.find(function (ac) {
    return ac.types.indexOf('point_of_interest') !== -1
  })
  if (streetNumber) {
    geopassage.numeroVoie = streetNumber.short_name

  } else {
    // Si le numéro de voie est tjrs manquant, on check le second objet ...
    addressComponents = res[1].address_components
    streetNumber = addressComponents.find(function (ac) {
      return ac.types.indexOf('street_number') !== -1 || ac.types.indexOf('political') !== -1;
    })
    if (streetNumber) {
      geopassage.numeroVoie = streetNumber.short_name
    } else if (avenue && avenue !== 'Bordeaux') {
      geopassage.numeroVoie = avenue.short_name
    } else {
      avenue = addressComponents.find(function (ac) {
        return ac.types.indexOf('point_of_interest') !== -1
      })
      if (avenue) {
        geopassage.numeroVoie = avenue.short_name
      }
    }
  }
  addressComponents = res[0].address_components
  let route = addressComponents.find(function (ac) {
    return ac.types.indexOf('route') !== -1
  })
  if (route) {
    geopassage.voie = route.short_name
  } else {
    // Si la rue est tjrs manquante, on check le second objet ...
    addressComponents = res[1].address_components
    route = addressComponents.find(function (ac) {
      return ac.types.indexOf('route') !== -1
    })
    if (route) {
      geopassage.voie = route.short_name
    } else {
      // On vérifie jusqu'à 3 objets ...
      addressComponents = res[2].address_components
      route = addressComponents.find(function (ac) {
        return ac.types.indexOf('route') !== -1
      })
      if (route) {
        geopassage.voie = route.short_name
      }
    }
  }
}, */


}



// WEBPACK FOOTER //
// ./src/store/api.js